import React, { useEffect } from "react";

const Home = ({ handleAppReset }) => {
    useEffect(() => {
        // Equivalent to componentDidMount
        handleAppReset();
    }, [handleAppReset]); // Dependency array ensures this runs only once
    
    return (
        <div className="Home"></div>
    );
    
}

export default Home;
